"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GaService = void 0;
const typedi_1 = require("typedi");
const utils_1 = require("@common/http/utils");
const sendAnalyticsEvents = require("./../../common/services/adl.js");
/**
 * Сервис Google Analytics
 */
let GaService = class GaService {
    /**
     * Отправляет события
     */
    setGaLayers(response) {
        const data = (0, utils_1.formatResponse)(response).data;
        if (!!data.dataLayers && !!data.dataLayers && !!data.dataLayers[data.dataLayerKey]) {
            this.dataLayerPusher(false, data.dataLayers[data.dataLayerKey]);
        }
    }
    /**
     * Отправляет событие аналитики
     */
    sendAnalytics(eventClass, event, domainName, conversionValue) {
        try {
            sendAnalyticsEvents(eventClass, event, domainName, conversionValue);
        }
        catch (err) {
            console.log(err);
        }
    }
    /**
     * Подготовливает данные
     */
    dataLayerPusher(key, value) {
        key = key || false;
        value = value || false;
        let dataLayerValue = window.artAjaxerPagerGoogleAnalytics[key];
        if (!key && value) {
            dataLayerValue = value;
        }
        //window.dataLayer.push(dataLayerValue);
    }
    /**
     * Добавляет слой с данными по доменам в GoogleAnalytics
     */
    pushGA(ga) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(ga);
    }
};
GaService = __decorate([
    (0, typedi_1.Service)()
], GaService);
exports.GaService = GaService;
